// 'YYYY-MM-DD' -> 'DD.MM.YYYY.'
export const formatAckDay = (s) => {
  if (!s || typeof s !== 'string') return '';
  const [y, m, d] = s.split('-');
  return d ? `${d}.${m}.${y}.` : s;
};

/**
 * Readable text of a Labour Law warning confirmed on a request, built from the
 * stored `kind` / `details` of a `lawWarningsAcknowledged` entry.
 *
 * Kinds on record:
 * - `firstBlock` (before 23.10.2026): first part shorter than 10 working days;
 *   details: newDaysInThisRequest, minRequired, lawArticle.
 * - `firstPart`: first part not used by the deadline; details: required,
 *   deadline ('YYYY-MM-DD'), year, ...
 * Any other kind gets a generic text.
 *
 * @param {Object} ack - One `lawWarningsAcknowledged` entry.
 * @param {Function} t - i18next `t`.
 * @returns {string}
 */
export const lawWarningAckText = (ack, t) => {
  const d = ack?.details || {};
  if (ack?.kind === 'firstBlock') {
    const minRequired =
      typeof d.minRequired === 'number' ? d.minRequired : 10;
    return typeof d.newDaysInThisRequest === 'number'
      ? t('lawWarningsAckFirstBlock', {
          ns: 'forms',
          used: d.newDaysInThisRequest,
          minRequired,
        })
      : t('lawWarningsAckFirstBlockNoDays', { ns: 'forms', minRequired });
  }
  if (ack?.kind === 'firstPart') {
    return t('lawWarningsAckFirstPart', {
      ns: 'forms',
      required: d.required ?? '—',
      deadline: formatAckDay(d.deadline) || '—',
    });
  }
  return t('lawWarningsAckGeneric', { ns: 'forms' });
};

/**
 * Line shown for an acknowledgement in short lists (HR requests tooltip): the
 * reason given, or the warning itself when no reason was stored (entries
 * created before the reason became mandatory).
 */
export const lawWarningAckSummary = (ack, t) => {
  const reason = String(ack?.reason ?? '').trim();
  return reason || lawWarningAckText(ack, t);
};
